import React, { useState, useRef, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';

const WasherOptions = ({
  value,
  setValue,
  label = 'Select Washer',
  freeSolo = true,
  required = false,
  size = 'small',
  fullWidth = true
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('')
  const debounceRef = useRef();

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const q = query || '';
      if (!q) {
        setOptions([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
      fetch(`${process.env.REACT_APP_SERVER_URI}/washers/options?search=${encodeURIComponent(q)}`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then(res => res.json())
        .then(result => {
          // backend may return array or { data: [...] }
          const list = Array.isArray(result) ? result : (result?.data || []);
          setOptions(list);
        })
        .catch(() => setOptions([]))
        .finally(() => setLoading(false));
    }, 400);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query]);

  return (
    <Autocomplete
      freeSolo={freeSolo}
      options={options}
      getOptionLabel={option =>
        typeof option === 'string'
          ? option
          : (option.name || '') + (option.phone ? ` (${option.phone})` : '')
      }
      loading={loading}
      value={value}
      onChange={(event, newVal) => setValue(newVal)}
      inputValue={query}
      onInputChange={(event, newQuery) => setQuery(newQuery)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          fullWidth={fullWidth}
          size={size}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default WasherOptions;